import { render, staticRenderFns } from "./OrderClaim.vue?vue&type=template&id=022d152a&scoped=true"
import script from "./OrderClaim.vue?vue&type=script&lang=js"
export * from "./OrderClaim.vue?vue&type=script&lang=js"
import style0 from "./OrderClaim.vue?vue&type=style&index=0&id=022d152a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022d152a",
  null
  
)

export default component.exports